import mutations from './mutations'
import writeoffFormArticles from '@/api/writeoffFormArticles'
import { notify } from '@/utils/error'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    saveItems: ({ commit, rootState }, { writeOffId, items }) => {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit ? rootState.businessUnits.currentBusinessUnit.id : null
        writeoffFormArticles.save({ businessUnitId, writeOffId, items })
          .then(response => {
            const items = response.data.items
            commit('setElements', { type: 'items', elements: { ...items } })
            resolve(items)
          })
          .catch(error => {
            error.response.data.errors[0].error_id = '1000custom'
            notify({ ...error })
            reject(error)
          })
      })
    }
  },

  mutations: {
    ...mutations
  }
}
